import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { Button, Modal, PageTitle } from 'web/src/app/root/components/common'
import { createDefaultBaitSettings } from 'web/src/utils'
import { BaitSettings } from 'web/src/app/root/components/common/bait-settings'
import { LocationConfirmThresholdResetModal } from './location-confirm-threshold-reset-modal'

const useStyles = makeStyles(theme => ({
    root: {
        maxHeight: '90vh',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column'
    },
    pageTitle: {
        marginBottom: 40
    }
}))

export const LocationBaitSettingsCreateModal = ({ onClose, open, onSave }) => {
    const classes = useStyles()
    const locale = useSelector(state => state.main.locale)
    const theme = useSelector(state => state.main.theme)

    const [
        isConfirmThresholdResetModalOpen,
        setIsConfirmThresholdResetModalOpen
    ] = useState(false)
    const [currentData, setCurrentData] = useState(createDefaultBaitSettings())

    const handleSave = newData => {
        console.log('newData', newData)
        setCurrentData(newData)
        onClose()
        setIsConfirmThresholdResetModalOpen(true)
    }

    const handleConfirmThresholdReset = () => {
        onSave(currentData)
    }

    useEffect(() => {
        if (open) {
            setCurrentData(createDefaultBaitSettings())
        }
    }, [open])

    return (
        <>
            <Modal
                size="xl"
                onClose={onClose}
                open={open}
                className={classes.root}
            >
                <PageTitle
                    title={locale.locations.baitSettings}
                    className={classes.pageTitle}
                />

                <BaitSettings
                    data={currentData}
                    canUpdate={true}
                    isDevice={false}
                    isLocationSettings={true}
                    fullSave={handleSave}
                    fullCancel={onClose}
                />
            </Modal>
            <LocationConfirmThresholdResetModal
                open={isConfirmThresholdResetModalOpen}
                onClose={() => setIsConfirmThresholdResetModalOpen(false)}
                onConfirmClick={handleConfirmThresholdReset}
            />
        </>
    )
}
